import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { I18nProvider } from "./i18n/I18nContext";
import Login from "./pages/Login";
import Header from "./components/Header";
import Couriers from "./pages/Couriers";
import GunlukKasa from "./pages/GunlukKasa";
import Masalar from "./pages/Masalar";
import Stok from "./pages/Stok";
import MasaTanimlari from "./pages/MasaTanimlari";
import PersonelTanimlari from "./pages/PersonelTanimlari";
import Siparisler from "./pages/Siparisler";
import Musteriler from "./pages/Musteriler";
import { PosTablePage } from "./components/pos/PosTablePage";
import MusteriSiparisEkle from "./pages/MusteriSiparisEkle";
import GenelAyarlar from "./pages/GenelAyarlar";
import OrderDetailsQrcod from "./pages/OrderDetailsQrcodV2";
import MasaTanimlariId from "./pages/MasaTanimlariId";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import NotFoundPage from "./pages/NotFoundPage";
import axios from "axios";
import DontActiveAcount from "./components/DontActiveAcount";
import { base_url } from "../src/api/index";
import Material from "./pages/Material";
import Expenses from "./pages/expenses";
import Kitchen from "./pages/Kitchen";
import PosPrinters from "./pages/PosPrinters";
// import StocksAdd from './components/stocksSetAdd';
import StockSetGenel from "./pages/StockSetGenel";
import { ToastContainer } from "react-toastify";
import { islandTransition } from "./components/ui/notify";
import { SyncProgressBar } from "./components/SyncIndicator";
import AppVersionBadge from "./components/AppVersionBadge";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { tick } from"./redux/timerSlice";
import { PermissionsProvider } from "./context/PermissionsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DeliveryOrdersPanel from "./components/pos/DeliveryOrdersPanel";

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
const App = () => {
  const location = useLocation();
  const [ActiveUser, setActiveUser] = useState(false);


   const dispatch = useDispatch<any>();
  const sessions = useSelector((state: any) => state.timer.sessions);

  useEffect(() => {
    const interval = setInterval(() => {
      Object.keys(sessions).forEach((id) => {
        dispatch(tick({ tableId: id }));
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [dispatch, sessions]);
  // Determine if the header should be shown
  const showHeader = !(
    location.pathname === "/" || location.pathname.startsWith("/adminPage") || location.pathname.startsWith("/order-details")
  );

  useEffect(() => {
    const fetchOrders = async () => {
      if (!localStorage.getItem("token")) return;

      try {
        await axios.get(`${base_url}/own-restaurants`, getHeaders());
      } catch (error: any) {
        // if (error.response && error.response.status === 401 && error.response.data.message === "Unauthenticated" ) {
        //     setActiveUser(true); // Set access denied if response status is 403
        // }
        if (
          error.response &&
          error.response.status === 403 &&
          error.response.data.message === "User does not belong to any  active restaurant."
        ) {
          setActiveUser(true); // Set access denied if response status is 403
        } else {
          console.error("Error fetching orders:", error);
        }
      }
    };
    fetchOrders();
  }, []);

  if (ActiveUser) return <DontActiveAcount sil={setActiveUser} />;
  return (
    <div>
      {/* Tək qlobal bildiriş konteyneri — bütün səhifələrin bildirişləri buradan
          çıxır. Görünüş src/components/ui/notify.tsx-dəki island-dır; toastify
          yalnız növbə/taymer motorudur, ona görə onun bütün öz chrome-u (ikon,
          bağlama düyməsi, progress bar, tema) burada söndürülüb.

          newestOnTop={false}: yığın aşağı doğru böyüyür — ən köhnəsi yuxarıda,
          yenisi altdan sürüşərək gəlir. Ekrandakı sayı 3-lə məhdudlaşdırmaq
          notify.tsx-dədir: toastify-ın `limit`-i artığını NÖVBƏYƏ salır (ən yeni
          hadisə gözləyir), biz isə ən köhnəsini sıxışdırırıq.

          pauseOnFocusLoss={false}: POS pəncərəsi çox vaxt fokusda olmur (mətbəx
          ekranı, arxa planda kassa). Default davranış fokus itəndə taymeri
          dondurur və bildiriş ekranda ilişib qalır. */}
      <ToastContainer
        position="top-center"
        transition={islandTransition}
        autoClose={5000}
        newestOnTop={false}
        hideProgressBar
        pauseOnFocusLoss={false}
        icon={false}
        closeButton={false}
        draggable={false}
        className="rz-toast-container"
        toastClassName="rz-toast"
        bodyClassName="rz-toast-body"
      />
      {/* İlk sinxron zamanı ekranın üstündə incə tərəqqi zolağı.
          Header-dən ƏVVƏL gəlir ki, hər səhifədə görünsün. */}
      <SyncProgressBar />
      {/* Ekranın altında, ortada: cari versiya + yeniləmə tərəqqisi.
          Header-dən kənarda dayanır ki, giriş ekranında da görünsün — texniki
          işçiyə versiya məhz orada lazım olur. */}
      <AppVersionBadge />
      {showHeader && <Header />}
      {/* Wolt / Bolt Food sifarişləri — hər səhifədə qəbul paneli. */}
      {showHeader && <DeliveryOrdersPanel />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/masalar"
          element={
            <ProtectedRoute>
              <Masalar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/masa-siparis/:id"
          element={
            <ProtectedRoute>
              <PosTablePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/siparisler"
          element={
            <ProtectedRoute>
              <Siparisler />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kitchen"
          element={
            <ProtectedRoute>
              <Kitchen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/musteriler"
          element={
            <ProtectedRoute>
              <Musteriler />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gunluk-kasa"
          element={
            <ProtectedRoute>
              <GunlukKasa />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stok"
          element={
            <ProtectedRoute>
              <Stok />
            </ProtectedRoute>
          }
        />
        <Route
          path="/couriers"
          element={
            <ProtectedRoute>
              <Couriers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/masa-tanimlari"
          element={
            <ProtectedRoute>
              <MasaTanimlari />
            </ProtectedRoute>
          }
        />
        <Route
          path="/masa-tanimlari/id"
          element={
            <ProtectedRoute>
              <MasaTanimlariId />
            </ProtectedRoute>
          }
        />
        <Route
          path="/personel-tanimlari"
          element={
            <ProtectedRoute>
              <PersonelTanimlari />
            </ProtectedRoute>
          }
        />
        <Route
          path="/muster-siparis-ekle/:id"
          element={
            <ProtectedRoute>
              <MusteriSiparisEkle />
            </ProtectedRoute>
          }
        />
        <Route
          path="/genel-ayarlar"
          element={
            <ProtectedRoute>
              <GenelAyarlar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/printers"
          element={
            <ProtectedRoute>
              <PosPrinters />
            </ProtectedRoute>
          }
        />
        <Route
          path="/material"
          element={
            <ProtectedRoute>
              <Material />
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <Expenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stocksadd"
          element={
            <ProtectedRoute>
              <StockSetGenel />
            </ProtectedRoute>
          }
        />
        <Route path="/order-details/:token" element={<OrderDetailsQrcod />} />

        <Route path="/adminPage" element={<AdminLogin />} />
        <Route path="/adminPage/dashboard" element={<Dashboard />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

const AppWithRouter = () => (
  <ThemeProvider>
    <I18nProvider>
      <BrowserRouter>
        <PermissionsProvider>
          <App />
        </PermissionsProvider>
      </BrowserRouter>
    </I18nProvider>
  </ThemeProvider>
);

export default AppWithRouter;



